import { reactive } from "@vue/composition-api";
import axios from "axios";
import qs from "qs";
import router from "@/router";

export default function loginStore() {
  type state = {};
  const state = reactive({
    loginInfor: {
      mail: '',
      password: '',
      showPassword: false,
      checkButtonConfirm: true,
      loginResponse: ''
    },
    loginError: {
      status: 200 as any
    } as any,
    registerInfor: {
      mail: ''
    }

  });
  const axiosinstance = axios.create({
    baseURL: process.env.VUE_APP_API_SERVER
  });
  axiosinstance.defaults.timeout = 20000;
  axiosinstance.interceptors.response.use(
    function (response) {
      // 200 OK
      return response;
    },
    function (err) {
      const isTimeOut = err.code === "ECONNABORTED";
      if (isTimeOut) {
        router.push("/timeout-error");
        return err;
      }
      if (!err.response) {
        router.push("/network-error");
        return err;
      } else {
        state.loginError = err.response;
      }
    }
  );


  return {
    get loginInfor() {
      return state.loginInfor
    },
    get loginError() {
      return state.loginError
    },
    get registerInfor() {
      return state.registerInfor
    },

    changeShowPassword() {
      state.loginInfor.showPassword = !state.loginInfor.showPassword
    },

    submit() {
      return new Promise(resolve => {
        const params = {
          mail: state.loginInfor.mail,
          password: state.loginInfor.password
        }

        axiosinstance
          .post(
            "company/v0/login",
            params,
            {
              headers: {
                "content-type": "application/json"
              }
            }
          )
          .then(response => {
            return !response
              ? resolve(state.loginError)
              : resolve(
                state.loginInfor.loginResponse = response.data
              );
          })
          .then(() => {
            state.loginInfor.mail = '',
            state.loginInfor.password = ''
          });
      })
    },

    changeAgreementFlag(token: string) {
      return new Promise(resolve => {
        axiosinstance
          .patch(
            "company/v0/agreement",
            window.localStorage.getItem("token"),
            {
              headers: {
                "content-type": "application/json",
                "Authorization": token
              }
            }
          )
          .then(response => {
            return !response
              ? resolve(state.loginError)
              : resolve(

              );
          })
      })
    },

    sendRegistMail() {
      return new Promise(resolve => {
        const params = {
          mail: state.registerInfor.mail,
        }

        axiosinstance
          .post(
            "company/v0/sendRegistMail",
            params,
            {
              headers: {
                "content-type": "application/json"
              }
            }
          )
          .then(response => {
            return !response
              ? resolve(state.loginError)
              : resolve(
                
              );
          })
          .then(() => {
            state.registerInfor.mail = ''
          });
      })
    }

  }
}

export type LoginStore = ReturnType<typeof loginStore>;